import React, { useState } from 'react';
import { TextField, Button, Typography, Paper, Box, Link, Grid, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { login } from '../api';  // Import login API function

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // Add loading state for button
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading
    setError(''); // Clear previous errors


    try {
      const loginResult = await login(username, password);  // Call login API

      if (loginResult && loginResult.data) {
        // Store the token securely (example: HttpOnly cookie; see notes below)
        // SecureCookie.set('token', loginResult.token, { path: '/' });  // Assuming a SecureCookie library

        localStorage.setItem('token', loginResult.data.token); //For DEMO ONLY

        onLogin(loginResult.data.token);
        navigate('/');  // Redirect to CRUD page
      } else {
        setError('Login failed: Invalid credentials');  // Handle login failure
      }
    } catch (err) {
      setError(`Login failed: ${err.message || 'Unknown error'}`);  // Handle API errors
    } finally {
      setLoading(false); // End loading
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}> {/* Grid to center content with margin-top */}
      <Grid item xs={12} sm={8} md={5} lg={4}> {/* Responsive item width */}

        <Paper elevation={6} sx={{ p: 3 }}>
          <Typography variant="h5" align="center" gutterBottom> {/* Centered heading with bottom margin */}
            Login
          </Typography>
          {error && <Typography color="error" align="center" sx={{ mb: 2 }}>{error}</Typography>} {/* Centered error with margin */}
          <form onSubmit={handleSubmit}>
            <Box mb={2}>
              <TextField
                fullWidth
                label="Username"
                variant="outlined"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                disabled={loading}
              />
            </Box>
            <Box mb={3}>
              <TextField
                fullWidth
                label="Password"
                type="password"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </Box>
            <Button variant="contained" color="primary" type="submit" fullWidth disabled={loading}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null} // Show spinner
            >
              {loading ? 'Logging In...' : 'Login'} {/* Change text while loading */}

            </Button>

            <Box mt={2} textAlign="center">
              <Link href="/forgot-password" variant="body2">
                Forgot Password?
              </Link>
            </Box>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default LoginPage;